import { AlignCenter, AlignLeft, AlignRight } from "lucide-react";
import styles from "./heading-alignment-field.module.css";

export type HeadingAlignment = "left" | "center" | "right";

export function HeadingAlignmentField({ name, value, onChange, label = "Başlık hizası" }: {
  name: string;
  value: HeadingAlignment;
  onChange: (value: HeadingAlignment) => void;
  label?: string;
}) {
  return <fieldset className={styles.field}>
    <legend>{label}</legend>
    <div>{([
      { value: "left", label: "Sol", Icon: AlignLeft },
      { value: "center", label: "Orta", Icon: AlignCenter },
      { value: "right", label: "Sağ", Icon: AlignRight },
    ] as const).map(({ value: choice, label, Icon }) => <label key={choice}>
      <input type="radio" name={name} value={choice} checked={value === choice} onChange={() => onChange(choice)}/>
      <span><Icon size={15} aria-hidden="true"/>{label}</span>
    </label>)}</div>
  </fieldset>;
}
